import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  constructor(private storage: Storage) {}

  get(key) {
    return this.storage.get(key);
  }

  set(key, value) {
    return this.storage.set(key, value);
  }

  remove(key) {
    return this.storage.remove(key);
  }

  clear() {
    return this.storage.clear();
  }
}
